// @flow

import React from "react"
import styled from "styled-components"
import useIsMobile from "../../hooks/useIsMobile"

const Text = styled.h1`
  font-size: ${p => (p.$isMobile ? 34 : 64)}px;
  font-weight: ${p => (p.$isMobile ? 300 : "bold")};
  line-height: normal;
  color: white;
}
`

type Props = {
  children: string
}

const HeroPrimary = ({ children }: Props): React$Element<any> => {
  const isMobile = useIsMobile()
  return <Text $isMobile={isMobile}>{children}</Text>
}

export default HeroPrimary
